import React from 'react'
import { css, keyframes } from 'emotion'
import { Grid, GridCell, Text, View } from 'oio-react'
import { Link, useParams } from 'react-router-dom'
import GlobalViewport from 'src/apps/Global/components/Viewport'
import InitiativeList from 'src/apps/Initiative/components/List'
import { useOrganization } from 'src/graphql/hooks'

const animateIn = keyframes`
   0% {
      opacity: 0;
      transform: translate3d(0, 5%, 0);
   }

   100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
   }
`

const InitiativeType = () => {
   const { initiativeTypeSlug } = useParams()
   const { organization } = useOrganization()
   const initiativeType = organization.initiativeTypes.find(t => t.slug === initiativeTypeSlug)

   const initiativeListFilter = {
      archived: 'exclude',
      sortBy: 'dateLastUpdated',
      typeIds: [initiativeType.id],
      limit: 11
   }

   return (
      <GlobalViewport>
         <View
            className={css`
               opacity: 1;
               animation: ${animateIn} 700ms ease both;
            `}
            minHeight="100vh"
            borderLeft="1px solid #222"
            padding="0px 30px"
            width="100%">
            <View
               display="flex"
               alignItems="center"
               height="80px[a-d] 100px[e-f]"
               paddingBottom="20px[a-d] 30px[e-f]">
               <Text color="#fff" size="8[a-d] 9[e-f]" letterSpacing="-0.5px">
                  {initiativeType.namePlural}
               </Text>
            </View>
            <Grid
               columns="1[a-b] 2[c] 3[d] 4[e-f]"
               spacing="15px[a-d] 20px[e-f]">
               <InitiativeList filter={initiativeListFilter}>
                  {initiativeList => initiativeList.items.map(initiative => (
                     <GridCell key={initiative.id}>
                        <Link to={`/initiatives-new/${initiative.slug}`}>
                           <View
                              display="flex"
                              paddingBottom="20px[a-d] 30px[e-f]">
                              <View flex="1 1 auto">
                                 <View
                                    paddingTop="60%"
                                    backgroundColor="#eee"
                                    backgroundImage={initiative.coverMedia && `url(${initiative.coverMedia?.file.thumbnailUrlW480})`}
                                    backgroundSize="cover"
                                    backgroundPosition="bottom center"
                                    backgroundRepeat="no-repeat"
                                    marginBottom="15px[a-d] 20px[e-f]"
                                 />
                                 <Text size="2" color="#aaa">
                                    {initiative.type.nameSingular}
                                 </Text>
                                 <View marginTop="2px">
                                    <Text
                                       size="3[a-c] 2.5[d] 3[e-f]"
                                       lineHeight="120%"
                                       weight="medium"
                                       color="#fff">
                                       {initiative.name}
                                    </Text>
                                 </View>
                                 {initiative.body.summary && (
                                    <View
                                       margin="5px 0px"
                                       maxHeight="55px[a-d] 55px[e-f]"
                                       style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis'
                                       }}>
                                       <Text
                                          size="2.5[a-c] 2[d] 2[e-f]"
                                          lineHeight="130%"
                                          color="#888">
                                          <div
                                             dangerouslySetInnerHTML={{
                                                __html: initiative.body.summary
                                             }}
                                          />
                                       </Text>
                                    </View>
                                 )}
                                 <View marginTop="5px[e-f]">
                                    <Text size="2" color="#aaa">
                                       {initiative.dateAdded}
                                    </Text>
                                 </View>
                              </View>
                           </View>
                        </Link>
                     </GridCell>
                  ))}
               </InitiativeList>
            </Grid>
         </View>
      </GlobalViewport>
   )
}

export default InitiativeType
